export default class DeviceUpgradeInfo {
    currentVersion?: string = undefined
    lastedVersion?: string = undefined
    needUpgrade!: boolean
    isUpgrading!: boolean
}
